//机器人
const robotBox            = () => import('@/components/robot/robotBox');
const robotSpeech         = () => import('@/components/robot/robotSpeech');
const addRobotSpeech      = () => import('@/components/robot/speech/addRobotSpeech');
const editRobotSpeech     = () => import('@/components/robot/speech/editRobotSpeech');




export default{
    path: '/robotBox',
    name: 'robotBox',
    component: robotBox,
    children: [
        { path: 'robotSpeech', component: robotSpeech, name: 'robotSpeech' }, 
        { path: 'addRobotSpeech', component: addRobotSpeech, name: 'addRobotSpeech' }, 
        { path: 'editRobotSpeech', component: editRobotSpeech, name: 'editRobotSpeech' }, 
    ]
}



// WEBPACK FOOTER //
// ./src/router/routes/robot.js